module.exports = __webpack_public_path__ + "src/assets/games/32/43.jpg";